import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ContactTypeList } from '@/components/modules/pages/contact/list/ContactTypeList';
import { PageHead } from '@/components/modules/Typography/head/PageHead';
export const ContactPageView = (props) => {
    const { className = '' } = props;
    return (_jsxs("div", Object.assign({ className: className }, { children: [_jsx(PageHead, { bgImageType: 'consultation', englishText: 'Contact', text: '各種お問い合わせ' }), _jsx("div", Object.assign({ className: 'pt-40 lg:pt-64 px-20 pb-64 lg:pb-80' }, { children: _jsx(ContactTypeList, { className: clsx('lg:w-[1020px] lg:max-w-full', 'mx-auto') }) }))] })));
};
